import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import version from "../../../components/version";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskVideo from "../../../components/maskVideo";
import './digitalizeOverview.less'
export default {
    name: "digitalizeOverview",
    data() {
        return {
            info:{
                title1: '构建您的私域流量',
                info1: [
                    '不论您经营着怎样的生意和店铺，不管是几千家门店还是从一家门店开始,',
                    '注重您的用户，持续不断地触达和经营他们就是生意之道！',
                    '联拓数科全系列的数字商业产品可以灵活运用在各种行业,',
                    '通过一张电子会员卡可以轻松整合线下流量,',
                    '我们的后台管理系统可以很简便地建立适合您自己业务的会员体系。',
                    '丰富的在线化触达工具和线上外卖与商城，一切都为了给您的生意注入新的活力。'
                ],
                title2: '必备工具',
                info2: [
                    '为用户提供一张可存入微信卡包的小精灵电子会员卡，',
                    '一个可以随时购买商品的门店小程序。',
                    '作为门店管理者，我们同时为您提供了移动端和电脑端的管理后台，',
                    '让您一手掌握生意信息。',
                    '好了，一个非常完美的开始，进行您的营销之旅吧！'
                ]
            },
            introduce: [
                {
                    title1: '小精灵电子会员卡',
                    title2: '',
                    bg: '#f9f9f9',
                    pic: 'img/digitalizeOverview/introduce1.png',
                    block: '',
                    linkType: 'router',
                    linkHref: '/digitalizeCard',
                    linkTxt: '了解更多',
                    info: [
                        {
                            title: '一键开卡',
                            info: '您的用户在开卡时，他／她的资料将自动从微信调出，不必像过去那样花许多时间填写，只要点击开卡就可以了。简便的体验可以让开卡量快速提升。'
                        },
                        {
                            title: '自动发券与核销',
                            info: '通过后台设定的营销活动规则，小精灵营销系统会按您需要的规则定时发券，用户到店后自动识别即可使用。'
                        },
                        {
                            title: '精准营销',
                            info: '我们根据会员的消费数据可以做各种纬度的标签，例如：所属门店、等级、消费频次、客单价、储值额度等，您可以根据标签所分层的人群进行精准的营销。'
                        },
                        {
                            title: '全量触送',
                            info: '无论您的用户有没有关注公众号，结合微信服务通知和模版消息，您都可以100％触达会员，不仅提高了触达率，还节省了短信通知的成本。'
                        }
                    ]
                },
                {
                    title1: '小精灵商户通',
                    title2: '移动化的门店管理助手',
                    bg: '#fff',
                    pic: 'img/digitalizeOverview/introduce2.png',
                    block: 'swap',
                    linkType: 'router',
                    linkHref: '/payMerchant',
                    linkTxt: '了解更多',
                    info: [
                        {
                            title: '轻量、便捷的移动收款工具',
                            info: '小精灵商户通更具备“笔笔都能听得到”的语音播报能力、优惠券核销能力与设备绑定能力。'
                        },
                        {
                            title: '多角色的权限能力',
                            info: '针对总部人员、门店店长和收银员，小精灵商户通提供不同权限的功能模块和页面，让业务流程更加严谨，极大降低运营风险。'
                        },
                        {
                            title: '实时对账',
                            info: '随时随地让您可以查看每一笔订单，收益和到账。'
                        },
                        {
                            title: '数据报表',
                            info: '您将每日定时收到门店的经营报表，小精灵商户通堪称您的“运营小秘书”。'
                        }
                    ]
                },
                {
                    title1: '商家小程序',
                    title2: '',
                    bg: '#f9f9f9',
                    pic: 'img/digitalizeOverview/introduce3.png',
                    block: '',
                    linkType: 'router',
                    linkHref: '/digitalizeApplets',
                    linkTxt: '了解更多',
                    info: [
                        {
                            title: '打通线下支付和会员卡券营销',
                            info: '真正实现用户与您在线上和线下无缝连接，更好地促进销售增长。'
                        },
                        {
                            title: '支持微信官方“小程序直播”',
                            info: '通过直播组件，可以在小程序中实现直播互动与商品销售的闭环，提升消费者购物体验。'
                        },
                        {
                            title: '支持首页自定义装修',
                            info: '支持轮播图、短视频展示、会员注册引导、优惠券领取。'
                        },
                        {
                            title: '无忧配送',
                            info: '对接了顺丰同城、美团、达达和闪送四个即时配送平台，让到家业务无忧进行。'
                        }
                    ]
                },
                {
                    title1: '小精灵商户管理后台',
                    title2: '您专属的数字化管理平台',
                    bg: '#fff',
                    pic: 'img/digitalizeOverview/introduce4.png',
                    block: 'swap',
                    linkType: 'router',
                    linkHref: '/digitalizeBackstage',
                    linkTxt: '了解更多',
                    info: [
                        {
                            title: '关注用户增长的营销能力',
                            info: '我们更加关注您的用户增长，并为之不断迭代可以促进拉新、复购、唤醒、提升客单价的各种工具能力，通过小精灵商户管理后台，您可以随着业务的发展，不断发挥创意去促进业绩的增长。'
                        },
                        {
                            title: '多渠道的销售和业务运营',
                            info: '一体化的业务管理中台，可以管理每个门店、订单、商品、员工。基于前端的整合支付，我们的商户管理后台具备打通线上和线下的多渠道销售能力。'
                        },
                        {
                            title: '便于决策的数据报表',
                            info: '随时随地让您可以查看每一笔订单，收益和到账。'
                        },
                        {
                            title: '数据报表',
                            info: '您可以在小精灵商户管理后台查看多维度的、实时的数据报表，更便于作出业务经营和门店活动的优化调整。'
                        }
                    ]
                }
            ],
            video: [
                {
                    title: '开始数字化运营',
                    tip: '第一步：将分散的客流归集起来',
                    txt: '线下的用户“流量”是分散的，您也会做一些类似公众号或直播来招揽生意，吸引更多用户的关注，所以，必须将所有用户聚集到小精灵商户管理后台，这是开始经营用户的第一步。从拥有第一张小精灵电子会员卡开始，你的生意已经步入了“升级状态”，无论何时何地，用户都可以被留存下来。',
                    num: 2,
                    bg: '#f0f1fd',
                    border: '0',
                    more: '更多聚合客流的方式',
                    info: [
                        {
                            title: '开卡有礼',
                            info: '扫码开卡，自动拉取用户微信数据，3秒开卡；开卡即可赠送积分、券、权益等，自动同步到微信-卡包；支付时出示付款码即可自动核销，让顾客体验更棒！',
                            video: '01-开卡有礼-配音.mp4',
                            pic: '/img/digitalizeOverview/video/14.png',
                            more: '了解更多'
                        },
                        {
                            title: '互动营销',
                            info: '通过幸运大转盘、摇一摇、开心刮刮乐、集字游戏等，结合门店大屏幕、微信社群，让顾客互动起来，让活动更有趣味性，引流顾客同时促进门店业绩增长！',
                            video: '24-互动营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/9.png',
                            more: '了解更多'
                        },
                        {
                            title: '推荐有礼',
                            info: '通过社交流量裂变帮助商家快速拉新，可以通过会员的社群分享、朋友圈裂变传播，配合企业微信群能力落地裂变更轻松！可设置推荐用户到店消费/储值后才有奖励，以较小成本有效拉新！',
                            video: '09-推荐有礼-配音.mp4',
                            pic: '/img/digitalizeOverview/video/18.png',
                            more: '了解更多'
                        },
                        {
                            title: '电子DM海报',
                            info: '可以把多种类的优惠券结合为一张电子海报；可以通过二维码、链接朋友圈社群等多渠道领取，用户领取后直接到微信卡包；轻松节约几万元的纸质传单成本，同时有效提高券的触达和使用率！',
                            video: '02-电子DM海报-配音.mp4',
                            pic: '/img/digitalizeOverview/video/5.png',
                            more: '了解更多'
                        },
                        {
                            title: '关注有礼',
                            info: '引导消费者关注品牌微信公众号，帮助商户多渠道构建私域流量！',
                            video: '23-关注有礼-配音.mp4',
                            pic: '/img/digitalizeOverview/video/8.png',
                            more: '了解更多'
                        },
                        {
                            title: '更多能力',
                            info: '构建是商户私域流量，建立商户数据资产，打造数字化门店！AI营销，让业绩增长更轻松！',
                            video: '',
                            pic: '/img/digitalizeOverview/video/7.png',
                            more: ''
                        }
                    ]
                },
                {
                    title: '',
                    tip: '第二步：让您的会员有效地“动”起来',
                    txt: '收款小精灵90%以上的商户都会从使用我们的营销系统开始建立自己的会员升级体系，以便让自己的忠诚用户获得更高的黏性，事实证明，他们的生意获得很良性的提升。',
                    num: 4,
                    bg: '#fff',
                    border: '1px solid #eceef1',
                    more: '更多运营用户和会员的方式',
                    info:[
                        {
                            title: '储值营销',
                            info: '设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，储值关联会员晋级和权益效果更佳，设置员工分销，增长显著！',
                            video: '05-储值营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/4.png',
                            more: '了解更多'
                        },
                        {
                            title: '付费卡',
                            info: '强力锁定客户消费的必备武器，圈出你的忠诚客户！对于用户来说“钱在哪，心就在哪”，所以愿意为你的会员权益付费的用户，一定是你的“高净值客户”。',
                            video: '11-付费卡-配音.mp4',
                            pic: '/img/digitalizeOverview/video/6.png',
                            more: '了解更多'
                        },
                        {
                            title: '拓客分销',
                            info: '会员开卡、储值、售卖付费卡都可以通过员工分销码做分销，每一个员工都是最好的分销员！同时记录每一个员工的数据，助力门店做员工考核和激励，把管理颗粒度精准到每个员工！',
                            video: '25-拓客营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/17.png',
                            more: '了解更多'
                        },
                        {
                            title: '积分商城',
                            info: '积分几乎是所有场景都会用到的营销策略，是商户的核心资产！但是积分一定要真正“动”起来才有价值！积分兑换优惠券、库存单品券、特价券，其实一个积分商城就可以搞定了！',
                            video: '07-积分商城-配音.mp4',
                            pic: '/img/digitalizeOverview/video/1.png',
                            more: '了解更多'
                        },
                        {
                            title: '消费有礼',
                            info: '阶梯消费有礼，提高客单价；定向、定时会员消费有礼，严控优惠门槛和成本；消费A赠送B，定向单品赠送，消减库存；消费返现，根据消费额等比例赠送余额，时时锁定消费者行为！',
                            video: '04-消费有礼-配音.mp4',
                            pic: '/img/digitalizeOverview/video/20.png',
                            more: '了解更多'
                        },
                        {
                            title: '计次卡',
                            info: '次卡、周卡、月卡、季卡、年卡，泛娱乐行业必备能力！可以通过卡券商城、在线商城、企业微信等多种渠道售卖，关联员工售卖拓客分销能力，切实有效的提高门店售卡收入！',
                            video: '03-计次卡-配音.mp4',
                            pic: '/img/digitalizeOverview/video/11.png',
                            more: '了解更多'
                        },
                        {
                            title: '小额储值',
                            info: '又可称为智能储值，降低储值门槛锁定复购，根据消费额度设置充值赠送余额，沉淀资金的同时，更能锁定消费，拉动复购，是多场景锁客神器！',
                            video: '06-小额储值-配音.mp4',
                            pic: '/img/digitalizeOverview/video/21.png',
                            more: '了解更多'
                        },
                        {
                            title: '卡券商城',
                            info: '卡券商城的核心是售卖各类优惠卡券，商户通过自有会员售卖卡券可以节约平台卖券的扣点成本，同时构建自有私域流量！同时结合付费券的秒杀使用效果更佳！',
                            video: '08-卡券商城-配音.mp4',
                            pic: '/img/digitalizeOverview/video/13.png',
                            more: '了解更多'
                        },
                        {
                            title: '生日关怀',
                            info: '对用户的生日关怀，是提升用户好感度的利器！在顾客生日时可以设置提前发券，预约消费的形式增强用户的触达与体验，刺激客户到店消费，做更懂用户的商家！',
                            video: '10-生日关怀-配音.mp4',
                            pic: '/img/digitalizeOverview/video/16.png',
                            more: '了解更多'
                        },
                        {
                            title: '沉默唤醒',
                            info: '唤醒沉默会员到店消费，清楚知道15天、30天、60天...未到店的顾客，根据会员标签定向激活，定向发券，节省营销成本！',
                            video: '13-沉默唤醒-配音.mp4',
                            pic: '/img/digitalizeOverview/video/2.png',
                            more: '了解更多'
                        },
                        {
                            title: '节日营销',
                            info: '会员日是门店促销的大日子，也是顾客对品牌的记忆点。会员日提前/当天的真正活动触达，可以极大的提高活动活跃度，促进用户到店消费！',
                            video: '14-会员日节日营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/29.png',
                            more: '了解更多'
                        },
                        {
                            title: '全量触达',
                            info: '通过小精灵会员标签，可以做全量触达，也可以通过标签定向触达。通过微信服务通知，100%有效且免费触达；还可以触达多种内容：门店优惠券、小程序、直播、秒杀链接等皆可！',
                            video: '15-会员全量触达-配音.mp4',
                            pic: '/img/digitalizeOverview/video/30.png',
                            more: '了解更多'
                        },
                        {
                            title: '折扣营销',
                            info: '折扣营销是一种常规的促销手段，一般仅用于指定等级的会员、付费等级的会员、或者重大节日才会使用，但是效果极佳。通过指定参与人、时间、商品种类、绑定储值等手段，可以带来意想不到的效果！',
                            video: '16-折扣营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/28.png',
                            more: '了解更多'
                        },
                        {
                            title: '满减营销',
                            info: '满减营销也是一种常规的促销手段，商家设置阶梯满减、每满减有效提高客单价！通过通过指定参与人、时间、商品种类、绑定储值等手段，一样可以带来意想不到的效果！',
                            video: '17-满减营销-配音.mp4',
                            pic: '/img/digitalizeOverview/video/27.png',
                            more: '了解更多'
                        },
                        {
                            title: '充值有礼',
                            info: '设置充值金额，赠送活动奖品，充值可赠送多张优惠券、多张次卡、多种单品券组合，达到锁定顾客多次消费的目的',
                            video: '18-充值有礼-配音.mp4',
                            pic: '/img/digitalizeOverview/video/3.png',
                            more: '了解更多'
                        },
                        {
                            title: '更多能力',
                            info: '构建是商户私域流量，建立商户数据资产，打造数字化门店！AI营销，让业绩增长更轻松！',
                            video: '',
                            pic: '/img/digitalizeOverview/video/7.png',
                            more: ''
                        },
                    ]
                },
                {
                    title: '',
                    tip: '第三步：创造更高的收益',
                    txt: '小精灵对您的数字化武装不仅改变了运营效率，更加提升了销售模式。从线下聚集的客流可以通过线上销售快速提升收入。小精灵的商家小程序，让你能够简便快速地上线一套小程序外卖或商城，还可以根据你的生意需求灵活组合线下的营销能力。',
                    num: 4,
                    bg: '#f0f1fd',
                    border: '0',
                    more: '更多提升业绩的方式',
                    info:[
                        {
                            title: '营销礼包',
                            info: '其实就是电子版的礼品卡，常用于：员工福利、送礼、开卡/活动大礼包场景，可以开卡赠送、可付费购买、可结合员工分销；组合出多种玩法！',
                            video: '19-营销礼包-配音.mp4',
                            pic: '/img/digitalizeOverview/video/25.png',
                            more: '了解更多'
                        },
                        {
                            title: '商城小程序',
                            info: '构建一个线上门店，拓展销售额！小精灵商城小程序：实现线上线下会员数据、优惠、余额打通；海量装修模板自定义；直播、秒杀、拼团多种趣味玩法；打通第三方配送无忧。',
                            video: '20-商城小程序-配音.mp4',
                            pic: '/img/digitalizeOverview/video/24.png',
                            more: '了解更多'
                        },
                        {
                            title: '营销价值报告',
                            info: '门店动态实时掌握，营销效果实时管理，用数据去驱动门店管理决策，方便老板及时调整运营策略，强大就是让自己领先一步！',
                            video: '12-经营价值报告-配音.mp4',
                            pic: '/img/digitalizeOverview/video/12.png',
                            more: '了解更多'
                        },
                        {
                            title: '外卖小程序',
                            info: '自建一个线上外卖门店，拓展销售额，构建自有私域流量，拒绝平台盘剥！小精灵外卖小程序：实现线上线下会员数据、优惠、余额打通；海量装修模板自定义；支持门店配送。',
                            video: '21-外卖小程序-配音.mp4',
                            pic: '/img/digitalizeOverview/video/19.png',
                            more: '了解更多'
                        },
                        {
                            title: '小精灵商户通',
                            info: '老板和店员的移动收银和会员管理助手，集收银、查账、核销、会员管理、报表、交接班、远程监控数据等于一体，老板和店员权限隔离，门店经营神器！',
                            video: '22-小精灵商户通-配音.mp4',
                            pic: '/img/digitalizeOverview/video/31.png',
                            more: '了解更多'
                        },
                        {
                            title: '更多能力',
                            info: '构建是商户私域流量，建立商户数据资产，打造数字化门店！AI营销，让业绩增长更轻松！',
                            video: '',
                            pic: '/img/digitalizeOverview/video/7.png',
                            more: ''
                        },
                    ]
                }
            ],
            pay: {
                title: '选择适合您的营销版本',
                tip: '按照不同的模块能力，提供不同的版本。',
                info: [
                    {
                        title: '免费版',
                        tip: '提供基础营销能力',
                        num: '0元',
                        txt: '不收取年费',
                        linkTxt: '免费入门',
                        linkType: 'href',
                        linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                        list: [
                            '支付结合领券',
                            '自动核券',
                            '电子DM单'
                        ]
                    },
                    {
                        title: '轻会员',
                        tip: '适合单店或轻连锁的客户',
                        num: '1999元',
                        txt: '每个门店每年',
                        linkTxt: '开始免费试用',
                        linkType: 'href',
                        linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                        list: [
                            '支付即会员',
                            '智能储值',
                            '卡券商城',
                            '积分商城',
                            '付费会员'
                        ]
                    },
                    {
                        title: '高级版',
                        tip: '适合业务规模化发展的客户',
                        num: '6800-12800元',
                        txt: '开设总部的年费，门店的价格见详',
                        linkTxt: '联系销售',
                        linkType: 'href',
                        linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                        list: [
                            '商家小程序',
                            '精准营销',
                            '定时营销',
                            '群发通知',
                            '生日关怀',
                            '活动营销',
                            '分销与导购'
                        ]
                    }
                ]
            },
            details: {
                title: '功能详情',
                txt: '如果您有特定解决方案的需求，可进行定制定价',
                linkTxt: '联系销售人员',
                linkType: 'href',
                linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# '
            },
            more: {
                title: '更多解决方案或特殊需求',
                info: [
                    {
                        linkTxt: '轻会员营销',
                        linkHref: 'http://www.liantuofu.com/#/miniVip',
                        linkType: 'href'
                    },
                    {
                        linkTxt: '加油站解决方案',
                        linkHref: 'https://www.yuque.com/lt/jjfa/cufgi4',
                        linkType: 'href'
                    },
                    {
                        linkTxt: '智慧校园',
                        linkHref: '/caseCampus',
                        linkType: 'router'
                    },
                    {
                        linkTxt: '商圈会员付',
                        linkHref: 'https://www.yuque.com/lt/jjfa/oe2lq1',
                        linkType: 'href'
                    }
                ]
            },
            talk: {
                person: '张先生 - 窑鸡王市场运营经理',
                info: [
                    '“我们的小精灵外卖小程序与门店的线下会员无缝结合。“'
                ]
            },
            rollList: [
                {
                    src: "/img/digitalizeOverview/roll1.png",
                    size: 3,
                },
                {
                    src: "/img/digitalizeOverview/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeOverview/roll3.png",
                    size: 4,
                },
                {
                    src: "/img/digitalizeOverview/roll4.png",
                    size: 3,
                },
                {
                    src: "/img/digitalizeOverview/roll5.png",
                    size: 2,
                }
            ],
            brand: [
                'img/digitalizeOverview/brand1.png',
                'img/digitalizeOverview/brand2.png',
                'img/digitalizeOverview/brand3.png',
                'img/digitalizeOverview/brand4.png'
            ]
        }
    },
    components: {
        skeleton,
		version,
        pay,
        QRCode,
        vueSeamlessScroll,
        maskVideo
    },
    mounted() {
        let _this = this;
        _this.$nextTick(function () {
            if(_this.$route.query.type==="operate"){
                setTimeout(function () {
                    document.title = '数字化运营';
                    document.querySelector('meta[name="keywords"]').setAttribute('content', '数字化运营，数字化升级');
                    document.querySelector('meta[name="description"]').setAttribute('content', '门店数字化运营分为三步：第一，将分散的客流聚起来；第二，让会员动起来；第三，让会员创造更高的收益，联拓为您提供了近30种营销工具和能力，全面助力门店数字化。');
                    document.getElementById("operate").scrollIntoView()
                },100)
            }
        });
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    },
    methods: {
        moreBtn(index){
            let _this = this;
            if(_this.video[index].num === 2){
                _this.video[index].num = 30
            }else{
                _this.video[index].num = 2
            }
        }
    }
}
